module.exports = __webpack_public_path__ + "media/zips/Transparent_By_GP_White_Logo-5995b41accac3900f7dc643609badb28.zip";